import { combineReducers } from 'redux';

import contactus from '@/components/modals/ContactUs/reducer';
import installApp from '@/components/modals/InstallApp/reducer';
import pushNotification from '@/components/NotificationPermissionModal/reducer';
import speedyFlowSlice from '@/components/SpeedyFlow/redux/slice';
import terms from '@/components/TermsAndConditions/redux/slice';

export default combineReducers({
  [terms.name]: terms.reducer,
  contactus,
  installApp,
  pushNotification,
  [speedyFlowSlice.name]: speedyFlowSlice.reducer,
});
